import { render } from "./EditTableForm.vue?vue&type=template&id=194d4544"
import script from "./EditTableForm.vue?vue&type=script&lang=js"
export * from "./EditTableForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__